import type { ProgramPagePdfData } from "../../programPages/types";

export const PLATFORM_REPORT_PLATFORMS = [
  { id: "youtube_videos", label: "YouTube Videos", surface: "YouTube Videos" },
  { id: "youtube_shorts", label: "YouTube Shorts", surface: "YouTube Shorts" },
  { id: "instagram", label: "Instagram", surface: "Instagram" },
  { id: "tiktok", label: "TikTok", surface: "TikTok" },
] as const;

/** Shown only when the selected programs published Facebook content. */
export const FACEBOOK_REPORT_PLATFORM = {
  id: "facebook",
  label: "Facebook",
  surface: "Facebook",
} as const;

export type PlatformReportId =
  | (typeof PLATFORM_REPORT_PLATFORMS)[number]["id"]
  | typeof FACEBOOK_REPORT_PLATFORM.id;

export type PlatformReportPlatform = {
  id: PlatformReportId;
  label: string;
  surface: string;
};

export const DEFAULT_PLATFORM_REPORT_IDS: PlatformReportId[] =
  PLATFORM_REPORT_PLATFORMS.map((platform) => platform.id);

const SURFACES = new Set<string>(
  PLATFORM_REPORT_PLATFORMS.map((platform) => platform.surface),
);

/** Program published on YouTube, Shorts, Instagram, or TikTok in the window. */
export function programPageHasPlatformReportActivity(
  page: ProgramPagePdfData,
): boolean {
  return page.metricRows.some((row) => {
    if (!SURFACES.has(row.surface)) return false;
    return (
      (Number(row.contentCount) || 0) > 0 ||
      (Number(row.totalViews) || 0) > 0 ||
      (Number(row.totalInteractions) || 0) > 0
    );
  });
}

/** Selected platforms, always in deck order. Facebook is added by the report builder. */
export function orderedPlatformReportPlatforms(
  ids: readonly PlatformReportId[],
): PlatformReportPlatform[] {
  const selected = new Set<string>(ids);
  return PLATFORM_REPORT_PLATFORMS.filter((platform) => selected.has(platform.id));
}
